module.exports = __webpack_public_path__ + "media/images/emblems/Chippis-af1b53e76d00d754a2c3a6ccdc06c312.png";